(function(){

var SIZE_CHART_OP = {
  XS: { bust:[80,84],  hips:[85,89],  torso:[46,49] },
  S:  { bust:[85,89],  hips:[90,94],  torso:[49,52] },
  M:  { bust:[90,94],  hips:[95,99],  torso:[52,55] },
  L:  { bust:[95,99],  hips:[100,104],torso:[55,58] },
  XL: { bust:[100,105],hips:[105,110],torso:[58,61] }
};
var SIZE_ORDER = ["XS","S","M","L","XL"];
var TALL_HEIGHT_THRESHOLD_CM = 175;
var LONG_TORSO_THRESHOLD_CM = 58;

var CSS_TEXT =".flowherSGop_trigger{margin:12px 0 12px;font-family:inherit;}" +
".flowherSGop_link{font-size:12px;letter-spacing:.02em;text-transform:uppercase;text-decoration:underline;color:#1A1A1A;background:none;padding:0;display:inline-block;cursor:pointer;font-weight:400;font-family:inherit;}" +
".flowherSGop_link:hover{color:#8A8A8A;}" +
"#flowherSGop_overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0);z-index:9998;opacity:0;pointer-events:none;transition:opacity .25s ease, background .25s ease;}" +
"#flowherSGop_drawer{position:fixed;z-index:9999;background:#FFFEFC;display:flex;flex-direction:column;transform:translateY(100%);transition:transform .32s cubic-bezier(.22,.61,.36,1);bottom:0;left:0;right:0;top:5%;border-radius:16px 16px 0 0;box-sizing:border-box;font-family:\"Swiss721LightExtendedBT\",\"Helvetica Neue\",Arial,sans-serif;visibility:hidden;}" +
"#flowherSGop_drawer *{box-sizing:border-box;font-family:inherit;}" +
"#flowherSGop_drawer.flowherSGop_isOpen{transform:translateY(0);visibility:visible;}" +
"#flowherSGop_overlay.flowherSGop_isOpen{background:rgba(0,0,0,.35);opacity:1;pointer-events:auto;}" +
"@media (min-width:768px){#flowherSGop_drawer{top:50%;left:50%;bottom:auto;right:auto;width:600px;max-height:88vh;transform:translate(-50%,-46%) scale(.98);opacity:0;border-radius:4px;transition:transform .28s ease, opacity .28s ease;}#flowherSGop_drawer.flowherSGop_isOpen{transform:translate(-50%,-50%) scale(1);opacity:1;}}" +
".flowherSGop_header{padding:22px 24px 14px;border-bottom:1px solid #E8E5E0;position:relative;flex-shrink:0;}" +
".flowherSGop_title{font-size:18px;letter-spacing:.02em;margin-bottom:6px;color:#1A1A1A;}" +
".flowherSGop_subtitle{font-size:13px;color:#6B6B6B;line-height:1.5;max-width:90%;}" +
".flowherSGop_close{position:absolute;top:20px;right:20px;background:none;border:none;font-size:16px;cursor:pointer;padding:4px;color:#1A1A1A;}" +
".flowherSGop_body{padding:20px 24px 32px;overflow-y:auto;flex:1;}" +
".flowherSGop_fieldsPair{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:14px;}" +
".flowherSGop_field{margin-bottom:14px;}" +
".flowherSGop_fieldLabelRow{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px;}" +
".flowherSGop_fieldLabel{font-size:12.5px;color:#1A1A1A;}" +
".flowherSGop_howtoLink{font-size:11px;color:#6B6B6B;text-decoration:underline;background:none;border:none;cursor:pointer;padding:0;}" +
".flowherSGop_inputWrap{position:relative;}" +
".flowherSGop_input{width:100%;padding:13px 40px 13px 14px;border:1px solid #E8E5E0;border-radius:2px;font-size:16px;background:#FFFEFC;color:#1A1A1A;}" +
".flowherSGop_input:focus{outline:none;border-color:#1A1A1A;}" +
".flowherSGop_unit{position:absolute;right:14px;top:50%;transform:translateY(-50%);font-size:12.5px;color:#6B6B6B;pointer-events:none;}" +
".flowherSGop_howto{display:none;background:#F6F4F0;border-radius:2px;padding:12px 14px;margin-top:6px;margin-bottom:8px;font-size:12px;color:#6B6B6B;line-height:1.55;grid-column:1/-1;}" +
".flowherSGop_howto.flowherSGop_open{display:block;}" +
".flowherSGop_sectionDivider{margin:20px 0 16px;padding-top:16px;border-top:1px solid #E8E5E0;}" +
".flowherSGop_sectionLabel{font-size:11px;letter-spacing:.05em;text-transform:uppercase;color:#6B6B6B;margin-bottom:12px;}" +
".flowherSGop_miniCta{width:100%;padding:14px;background:#1A1A1A;color:#FFFEFC;border:none;border-radius:2px;font-size:13px;letter-spacing:.03em;text-transform:uppercase;cursor:pointer;margin-top:4px;}" +
".flowherSGop_warning{font-size:12px;color:#8a6d3b;background:#FBF6EC;padding:10px 12px;border-radius:2px;line-height:1.5;margin-top:12px;display:none;}" +
".flowherSGop_warning.flowherSGop_visible{display:block;}" +
".flowherSGop_errorBlocking{font-size:12.5px;color:#B23B3B;background:#FBEAEA;border:1px solid #E5B8B8;padding:12px 14px;border-radius:2px;line-height:1.5;margin-top:12px;display:none;}" +
".flowherSGop_errorBlocking.flowherSGop_visible{display:block;}" +
".flowherSGop_tallNote{font-size:12px;color:#1A1A1A;background:#F6F4F0;padding:10px 12px;border-radius:2px;line-height:1.5;margin-top:10px;display:none;}" +
".flowherSGop_tallNote.flowherSGop_visible{display:block;}" +
".flowherSGop_tallNote + .flowherSGop_tallNote{margin-top:8px;}" +
".flowherSGop_summary{margin-top:24px;padding:20px;background:#F6F4F0;border-radius:4px;display:none;}" +
".flowherSGop_summary.flowherSGop_visible{display:block;}" +
".flowherSGop_summaryLabel{font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B6B6B;margin-bottom:10px;}" +
".flowherSGop_summaryValue{font-size:30px;letter-spacing:.02em;color:#1A1A1A;margin-bottom:12px;}" +
".flowherSGop_summaryNote{font-size:12.5px;color:#6B6B6B;line-height:1.6;margin-bottom:16px;}" +
".flowherSGop_ctaFinal{width:100%;padding:16px;background:#1A1A1A;color:#FFFEFC;border:none;border-radius:2px;font-size:13.5px;letter-spacing:.04em;text-transform:uppercase;cursor:pointer;}" +
".flowherSGop_ctaFinal:disabled{background:#E8E5E0;color:#6B6B6B;cursor:not-allowed;}" +
".flowherSGop_tableToggle{width:100%;text-align:left;background:none;border:none;border-top:1px solid #E8E5E0;padding:16px 0;font-size:13px;cursor:pointer;display:flex;justify-content:space-between;align-items:center;margin-top:22px;color:#1A1A1A;}" +
".flowherSGop_tableContent{display:none;}" +
".flowherSGop_tableContent.flowherSGop_open{display:block;}" +
".flowherSGop_sizeTable{width:100%;border-collapse:collapse;font-size:12px;margin-top:8px;}" +
".flowherSGop_sizeTable th,.flowherSGop_sizeTable td{padding:9px 5px;text-align:center;border-bottom:1px solid #E8E5E0;color:#1A1A1A;}" +
".flowherSGop_sizeTable th{color:#6B6B6B;font-weight:400;font-size:10.5px;text-transform:uppercase;}" +
".flowherSGop_sizeTable td:first-child,.flowherSGop_sizeTable th:first-child{text-align:left;font-weight:500;}" +
"@media (max-width:400px){.flowherSGop_sizeTable{font-size:10.5px;}.flowherSGop_sizeTable th,.flowherSGop_sizeTable td{padding:7px 3px;}.flowherSGop_fieldsPair{grid-template-columns:1fr;}}" +
".flowherSGop_modelRef{font-size:11.5px;color:#6B6B6B;margin-top:14px;line-height:1.6;font-style:italic;}";

var TRIGGER_HTML = '<button type="button" id="flowherSGop_open" class="flowherSGop_link">Guide des tailles</button>';

var DRAWER_HTML =
'<div id="flowherSGop_overlay"></div>' +
'<div id="flowherSGop_drawer">' +
  '<div class="flowherSGop_header">' +
    '<button type="button" id="flowherSGop_close" class="flowherSGop_close">X</button>' +
    '<div class="flowherSGop_title">Guide des tailles - ARIA</div>' +
    '<div class="flowherSGop_subtitle">Ce modele une piece se choisit en une seule taille. Renseignez vos mensurations pour obtenir votre recommandation.</div>' +
  '</div>' +
  '<div class="flowherSGop_body">' +
    '<div class="flowherSGop_fieldsPair">' +
      '<div class="flowherSGop_field"><div class="flowherSGop_fieldLabelRow"><label class="flowherSGop_fieldLabel">Poitrine</label><button type="button" class="flowherSGop_howtoLink" data-target="flowherSGop_howtoBust">Comment mesurer ?</button></div>' +
        '<div class="flowherSGop_inputWrap"><input type="number" inputmode="decimal" class="flowherSGop_input" id="flowherSGop_mBust" placeholder="90"><span class="flowherSGop_unit">cm</span></div></div>' +
      '<div class="flowherSGop_field"><div class="flowherSGop_fieldLabelRow"><label class="flowherSGop_fieldLabel">Hanches</label><button type="button" class="flowherSGop_howtoLink" data-target="flowherSGop_howtoHips">Comment mesurer ?</button></div>' +
        '<div class="flowherSGop_inputWrap"><input type="number" inputmode="decimal" class="flowherSGop_input" id="flowherSGop_mHips" placeholder="95"><span class="flowherSGop_unit">cm</span></div></div>' +
      '<div class="flowherSGop_howto" id="flowherSGop_howtoBust">Mesurez horizontalement autour de la partie la plus forte de votre poitrine.</div>' +
      '<div class="flowherSGop_howto" id="flowherSGop_howtoHips">Mesurez autour de la partie la plus large de vos hanches.</div>' +
    '</div>' +

    '<div class="flowherSGop_sectionDivider"><div class="flowherSGop_sectionLabel">Morphologie (optionnel, affine la recommandation)</div></div>' +

    '<div class="flowherSGop_fieldsPair">' +
      '<div class="flowherSGop_field"><div class="flowherSGop_fieldLabelRow"><label class="flowherSGop_fieldLabel">Taille debout</label><button type="button" class="flowherSGop_howtoLink" data-target="flowherSGop_howtoHeight">Comment mesurer ?</button></div>' +
        '<div class="flowherSGop_inputWrap"><input type="number" inputmode="decimal" class="flowherSGop_input" id="flowherSGop_mHeight" placeholder="172"><span class="flowherSGop_unit">cm</span></div></div>' +
      '<div class="flowherSGop_field"><div class="flowherSGop_fieldLabelRow"><label class="flowherSGop_fieldLabel">Hauteur de buste</label><button type="button" class="flowherSGop_howtoLink" data-target="flowherSGop_howtoTorso">Comment mesurer ?</button></div>' +
        '<div class="flowherSGop_inputWrap"><input type="number" inputmode="decimal" class="flowherSGop_input" id="flowherSGop_mTorso" placeholder="53"><span class="flowherSGop_unit">cm</span></div></div>' +
      '<div class="flowherSGop_howto" id="flowherSGop_howtoHeight">Indiquez votre taille debout (en cm), pieds nus. Au-dessus d\'1m75, un maintien renforce est recommande sur ce modele echancre.</div>' +
      '<div class="flowherSGop_howto" id="flowherSGop_howtoTorso">Mesurez la distance entre le haut de l\'epaule et l\'entrejambe, en passant par-dessus la poitrine (comme pour un justaucorps). Cette mesure est independante de votre taille debout.</div>' +
    '</div>' +

    '<button type="button" class="flowherSGop_miniCta" id="flowherSGop_cta">Calculer ma taille</button>' +
    '<div class="flowherSGop_warning" id="flowherSGop_warning"></div>' +
    '<div class="flowherSGop_tallNote" id="flowherSGop_tallNoteHeight">Vous mesurez plus d\'1m75 : nous vous recommandons de prendre une taille au-dessus de votre taille habituelle pour un maintien optimal sur ce modele.</div>' +
    '<div class="flowherSGop_tallNote" id="flowherSGop_tallNoteTorso">Vous avez un buste long : nous vous recommandons de prendre une taille au-dessus pour eviter toute tension au niveau de l\'entrejambe.</div>' +
    '<div class="flowherSGop_errorBlocking" id="flowherSGop_errorStock"></div>' +
    '<div class="flowherSGop_summary" id="flowherSGop_summary">' +
      '<div class="flowherSGop_summaryLabel">Votre taille recommandee</div>' +
      '<div class="flowherSGop_summaryValue" id="flowherSGop_summaryValue">-</div>' +
      '<div class="flowherSGop_summaryNote" id="flowherSGop_summaryNote"></div>' +
      '<button type="button" class="flowherSGop_ctaFinal" id="flowherSGop_ctaFinal">Ajouter au panier dans cette taille</button>' +
    '</div>' +
    '<button type="button" class="flowherSGop_tableToggle" id="flowherSGop_tableToggle"><span>Tableau des tailles</span><span id="flowherSGop_tableToggleIcon">+</span></button>' +
    '<div class="flowherSGop_tableContent" id="flowherSGop_tableContent">' +
      '<table class="flowherSGop_sizeTable"><thead><tr><th>Taille</th><th>Poitrine</th><th>Hanches</th><th>Hauteur buste</th></tr></thead><tbody id="flowherSGop_sizeTableBody"></tbody></table>' +
      '<div class="flowherSGop_modelRef">Le modele mesure 172 cm, buste 82 cm, taille 61 cm, hanches 85 cm - elle porte du S. Si vous mesurez plus d\'1m75 ou avez un buste long, prenez une taille au-dessus.</div>' +
    '</div>' +
  '</div>' +
'</div>';

function injectStyles(){
  if (document.getElementById("flowherSGop_styles")) { return; }
  var style = document.createElement("style");
  style.id = "flowherSGop_styles";
  style.textContent = CSS_TEXT;
  document.head.appendChild(style);
}

function injectTrigger(){
  var addToCartBtn = document.querySelector(".product-form__submit.add-to-cart");
  if (!addToCartBtn) { return false; }
  if (document.getElementById("flowherSGop_open")) { return true; }
  var wrapper = document.createElement("div");
  wrapper.className = "flowherSGop_trigger";
  wrapper.innerHTML = TRIGGER_HTML;
  addToCartBtn.parentNode.insertBefore(wrapper, addToCartBtn);
  return true;
}

function injectDrawer(){
  if (document.getElementById("flowherSGop_drawer")) { return; }
  var wrapper = document.createElement("div");
  wrapper.id = "flowherSGop_root";
  wrapper.innerHTML = DRAWER_HTML;
  document.body.appendChild(wrapper);
}

function findSizeForValue(value, key){
  for (var i=0; i<SIZE_ORDER.length; i++){
    var size = SIZE_ORDER[i];
    var range = SIZE_CHART_OP[size][key];
    if (value >= range[0] && value <= range[1]) return size;
  }
  if (value < SIZE_CHART_OP[SIZE_ORDER[0]][key][0]) return SIZE_ORDER[0];
  if (value > SIZE_CHART_OP[SIZE_ORDER[SIZE_ORDER.length-1]][key][1]) return SIZE_ORDER[SIZE_ORDER.length-1];
  for (var j=0; j<SIZE_ORDER.length-1; j++){
    var currentMax = SIZE_CHART_OP[SIZE_ORDER[j]][key][1];
    var nextMin = SIZE_CHART_OP[SIZE_ORDER[j+1]][key][0];
    if (value > currentMax && value < nextMin) return SIZE_ORDER[j+1];
  }
  return SIZE_ORDER[Math.floor(SIZE_ORDER.length/2)];
}
function sizeIndex(size){ return SIZE_ORDER.indexOf(size); }
function upgradeSize(size){
  var idx = sizeIndex(size);
  return idx < SIZE_ORDER.length-1 ? SIZE_ORDER[idx+1] : size;
}

function recommendOnePiece(bust, hips, height, torso){
  var bustSize = findSizeForValue(bust, "bust");
  var hipsSize = findSizeForValue(hips, "hips");
  var baseSize = sizeIndex(bustSize) >= sizeIndex(hipsSize) ? bustSize : hipsSize;
  var inconsistent = Math.abs(sizeIndex(bustSize) - sizeIndex(hipsSize)) >= 2;

  var isTallHeight = !!height && height >= TALL_HEIGHT_THRESHOLD_CM;
  var isLongTorso = !!torso && torso >= LONG_TORSO_THRESHOLD_CM;

  var finalSize = baseSize;
  if (isTallHeight || isLongTorso) { finalSize = upgradeSize(baseSize); }

  return { size: finalSize, inconsistent: inconsistent, isTallHeight: isTallHeight, isLongTorso: isLongTorso };
}

function openDrawer(){
  var drawer = document.getElementById("flowherSGop_drawer");
  var overlay = document.getElementById("flowherSGop_overlay");
  if (!drawer || !overlay) { return; }
  drawer.classList.add("flowherSGop_isOpen");
  overlay.classList.add("flowherSGop_isOpen");
  document.body.style.overflow = "hidden";
}
function closeDrawer(){
  var drawer = document.getElementById("flowherSGop_drawer");
  var overlay = document.getElementById("flowherSGop_overlay");
  if (!drawer || !overlay) { return; }
  drawer.classList.remove("flowherSGop_isOpen");
  overlay.classList.remove("flowherSGop_isOpen");
  document.body.style.overflow = "";
}

var state = { size: null };

function findSizeOptionPosition(){
  var fieldsets = document.querySelectorAll(".swatch-wrapper");
  for (var i=0; i<fieldsets.length; i++){
    var legend = fieldsets[i].querySelector(".swatch-header");
    if (!legend) continue;
    var txt = legend.textContent.toLowerCase();
    if (txt.indexOf("taille") !== -1 || txt.indexOf("size") !== -1){
      var body = fieldsets[i].querySelector(".swatch-body");
      if (body && body.getAttribute("data-option-index")) return body.getAttribute("data-option-index");
      var anyRadio = fieldsets[i].querySelector("input.js-option-item");
      if (anyRadio) return anyRadio.getAttribute("data-option-position");
    }
  }
  return null;
}

function getSizeRadio(sizeValue){
  var optionPosition = findSizeOptionPosition();
  var radios = document.querySelectorAll("input.js-option-item");
  for (var r=0; r<radios.length; r++){
    var radio = radios[r];
    var matchesValue = radio.value.replace(/^\s+|\s+$/g, "").toUpperCase() === sizeValue;
    var matchesPosition = optionPosition ? (radio.getAttribute("data-option-position") === optionPosition) : true;
    if (matchesValue && matchesPosition) { return radio; }
  }
  return null;
}

function bindAll(){
  var drawer = document.getElementById("flowherSGop_drawer");
  var overlay = document.getElementById("flowherSGop_overlay");
  var openBtn = document.getElementById("flowherSGop_open");
  var closeBtn = document.getElementById("flowherSGop_close");
  if (!drawer || !overlay || !openBtn || !closeBtn) { return; }
  if (openBtn.getAttribute("data-bound") === "1") { return; }
  openBtn.setAttribute("data-bound", "1");

  openBtn.addEventListener("click", function(e){ e.preventDefault(); openDrawer(); });
  closeBtn.addEventListener("click", function(e){ e.preventDefault(); closeDrawer(); });
  overlay.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function(e){ if(e.key==="Escape") closeDrawer(); });

  var howtoLinks = drawer.querySelectorAll(".flowherSGop_howtoLink");
  for (var h=0; h<howtoLinks.length; h++){
    howtoLinks[h].addEventListener("click", function(){
      var target = document.getElementById(this.getAttribute("data-target"));
      var allHowtos = drawer.querySelectorAll(".flowherSGop_howto");
      for (var n=0; n<allHowtos.length; n++){ if (allHowtos[n] !== target) allHowtos[n].classList.remove("flowherSGop_open"); }
      target.classList.toggle("flowherSGop_open");
    });
  }

  function refreshStockState(){
    var errorStock = document.getElementById("flowherSGop_errorStock");
    var ctaFinal = document.getElementById("flowherSGop_ctaFinal");
    if (!state.size) { errorStock.classList.remove("flowherSGop_visible"); return; }
    var radio = getSizeRadio(state.size);
    if (!radio){
      errorStock.textContent = "Impossible de localiser cette taille sur la fiche produit. Contactez-nous pour verifier la disponibilite.";
      errorStock.classList.add("flowherSGop_visible");
      ctaFinal.disabled = true;
      return;
    }
    if (radio.disabled){
      errorStock.textContent = "La taille " + state.size + " est actuellement en rupture de stock. Ajout au panier impossible pour cette taille.";
      errorStock.classList.add("flowherSGop_visible");
      ctaFinal.disabled = true;
    } else {
      errorStock.classList.remove("flowherSGop_visible");
      ctaFinal.disabled = false;
    }
  }

  document.getElementById("flowherSGop_cta").addEventListener("click", function(){
    var bust = parseFloat(document.getElementById("flowherSGop_mBust").value);
    var hips = parseFloat(document.getElementById("flowherSGop_mHips").value);
    var height = parseFloat(document.getElementById("flowherSGop_mHeight").value);
    var torso = parseFloat(document.getElementById("flowherSGop_mTorso").value);
    var warning = document.getElementById("flowherSGop_warning");
    var tallNoteHeight = document.getElementById("flowherSGop_tallNoteHeight");
    var tallNoteTorso = document.getElementById("flowherSGop_tallNoteTorso");
    var summary = document.getElementById("flowherSGop_summary");

    if (!bust || !hips){
      warning.textContent = "Merci de renseigner au minimum votre poitrine et vos hanches.";
      warning.classList.add("flowherSGop_visible");
      summary.classList.remove("flowherSGop_visible");
      return;
    }

    var result = recommendOnePiece(bust, hips, height, torso);
    state.size = result.size;

    warning.classList.toggle("flowherSGop_visible", result.inconsistent);
    if (result.inconsistent) { warning.textContent = "Vos mesures de poitrine et de hanches correspondent a des tailles assez differentes. Nous avons retenu la taille la plus large pour un maintien confortable."; }

    tallNoteHeight.classList.toggle("flowherSGop_visible", result.isTallHeight);
    tallNoteTorso.classList.toggle("flowherSGop_visible", result.isLongTorso);

    document.getElementById("flowherSGop_summaryValue").textContent = state.size;
    var note;
    if (result.isTallHeight && result.isLongTorso) {
      note = "Taille ajustee automatiquement suite a votre taille debout et votre hauteur de buste, toutes deux superieures a la moyenne.";
    } else if (result.isTallHeight) {
      note = "Taille ajustee automatiquement suite a votre taille debout superieure a 1m75.";
    } else if (result.isLongTorso) {
      note = "Taille ajustee automatiquement suite a votre hauteur de buste, superieure a la moyenne pour ce modele.";
    } else {
      note = "Recommandation basee sur vos mensurations. En cas de doute entre deux tailles, privilegiez la taille superieure pour ce modele echancre.";
    }
    document.getElementById("flowherSGop_summaryNote").textContent = note;
    summary.classList.add("flowherSGop_visible");
    refreshStockState();
  });

  function selectShopifySize(sizeValue){
    var radio = getSizeRadio(sizeValue);
    if (!radio || radio.disabled) { return false; }
    radio.checked = true;
    radio.dispatchEvent(new Event("change", { bubbles: true }));
    radio.dispatchEvent(new Event("click", { bubbles: true }));
    var allLabels = document.getElementsByTagName("label");
    for (var lb=0; lb<allLabels.length; lb++){
      if (allLabels[lb].getAttribute("for") === radio.id){ allLabels[lb].click(); break; }
    }
    return true;
  }

  document.getElementById("flowherSGop_ctaFinal").addEventListener("click", function(){
    if (!state.size) return;
    refreshStockState();
    var radio = getSizeRadio(state.size);
    if (!radio || radio.disabled) { return; }
    var ok = selectShopifySize(state.size);
    if (!ok) return;
    closeDrawer();
    setTimeout(function(){
      var submitBtn = document.querySelector(".product-form__submit.add-to-cart");
      if (submitBtn && !submitBtn.disabled) { submitBtn.click(); }
    }, 200);
  });

  var tbody = document.getElementById("flowherSGop_sizeTableBody");
  var rowsHtml = "";
  for (var s=0; s<SIZE_ORDER.length; s++){
    var size = SIZE_ORDER[s];
    var d = SIZE_CHART_OP[size];
    rowsHtml += "<tr><td>" + size + "</td><td>" + d.bust[0] + "-" + d.bust[1] + " cm</td><td>" + d.hips[0] + "-" + d.hips[1] + " cm</td><td>" + d.torso[0] + "-" + d.torso[1] + " cm</td></tr>";
  }
  tbody.innerHTML = rowsHtml;

  document.getElementById("flowherSGop_tableToggle").addEventListener("click", function(){
    var content = document.getElementById("flowherSGop_tableContent");
    var icon = document.getElementById("flowherSGop_tableToggleIcon");
    content.classList.toggle("flowherSGop_open");
    icon.textContent = content.classList.contains("flowherSGop_open") ? "-" : "+";
  });
}

function init(){
  var triggerOk = injectTrigger();
  if (!triggerOk) { return; }
  injectStyles();
  injectDrawer();
  bindAll();
}

function scheduleInit(){
  init();
  setTimeout(init, 500);
  setTimeout(init, 1500);
  setTimeout(init, 3000);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", scheduleInit);
} else {
  scheduleInit();
}

})();